import styles from './index.module.less';
import Image from 'next/image';
import { useTranslation } from 'next-i18next';
import { capitalizeFirstLetter } from '@/lib/hooks/utils/utils';

const Index = ({ platList }: { platList: any }) => {
  const { t } = useTranslation();
  return (
    <div className={styles.container}>
      <div className={styles.content_head}>
        <Image src={platList.icon} alt={platList.platform} height={30} priority width={30} />
        <span>{capitalizeFirstLetter(platList.platform)}</span>
      </div>
      <div className={styles.description}>{capitalizeFirstLetter(t(platList.description))}</div>
      <div className={styles.url}>
        URL:
        <span onClick={() => window.open(platList.url, '_blank')}>{platList.url}</span>
      </div>
      <ul className={styles.i_tag}>
        <span>{t('tags')}:</span>
        {platList.tags.map((item: string, index: number) => (
          <li key={index}>{t(item)}</li>
        ))}
      </ul>
      {/* <div className={styles.mainImg}>
        <div>
          <Image
            src={platList.image}
            alt={platList.platform}
            layout="responsive"
            loading="lazy"
            width={500}
            height={500}
          />
        </div>
      </div> */}
    </div>
  );
};

export default Index;
